<template>
  <employee-form
    :init-employee="initEmployee"
    :successMsg="t('created')"
    :submitAction="submit"
    enableClearForm
    clearFormOnSubmit
  />
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import EmployeeForm from '@/views/hr/employees/EmployeeForm.vue'

import { useI18n } from 'vue-i18n'
import User from '@/models/user/User'
import { useHTTP } from '@/plugins/http'
import LoadingSpinner from '@/components/LoadingSpinner.vue'
import AlertBadge from '@/components/AlertBadge.vue'
import { router } from '@/router'

export default defineComponent({
  name: 'new-employee',
  components: {
    EmployeeForm
  },
  setup() {
    const error = ref({ title: '', body: '' })

    const { t } = useI18n({
      messages: {
        en: {
          created: 'Employee was created successfully'
        },
        ar: {
          created: 'تم انشاء الموظف بنجاح'
        }
      }
    })

    return {
      t,
      error
    }
  },
  data() {
    return {
      initEmployee: new User()
    }
  },

  methods: {
    async submit(employee: User, avatarFile: File | null, attachmentFiles: File[] = []) {
      try {
        const formData = new FormData()
        formData.set('employee', JSON.stringify(employee))
        if (avatarFile) {
          formData.set('avatar', avatarFile)
        }
        attachmentFiles.forEach((file) => formData.append('attachments', file))
        await this.$http.post(User.ENDPOINT, formData)
        router.back()
      } catch (error) {
        setTimeout(() => {
          /* @ts-ignore */
          window.scrollTo(0, 0)

          /* @ts-ignore */
          document.querySelector('.el-form').scrollIntoView()
        }, 100)
        return error
      }
    }
  }
})
</script>

<style></style>
